/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Execute_Detail7Inputs */

const en_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly demos, core loop first.`)
};

const ar_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروض أسبوعية، والحلقة الأساسية أولا.`)
};

const bn_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাপ্তাহিক ডেমো, মূল লুপ আগে।`)
};

const de_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wöchentliche Demos, Kernschleife zuerst.`)
};

const es_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos semanales, el ciclo principal primero.`)
};

const fr_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démos hebdomadaires, boucle principale d'abord.`)
};

const pt_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos semanais, o ciclo principal primeiro.`)
};

const zh_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每周演示，核心链路先行。`)
};

const tr_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haftalık demolar, önce ana döngü.`)
};

const ru_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Еженедельные демо, главный цикл в первую очередь.`)
};

const pl_svc_mvp_sprint_execute_detail7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cotygodniowe dema, najpierw główna pętla.`)
};

/**
* | output |
* | --- |
* | "Weekly demos, core loop first." |
*
* @param {Svc_Mvp_Sprint_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_execute_detail7 = /** @type {((inputs?: Svc_Mvp_Sprint_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "de") return de_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "es") return es_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_execute_detail7(inputs)
	return en_svc_mvp_sprint_execute_detail7(inputs)
});
export { svc_mvp_sprint_execute_detail7 as "svc_mvp-sprint_EXECUTE_detail" }